"use client";

import { useState } from "react";

import NextContainer from "~/componentsDS/Layout/Container";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import { cn } from "~/lib/utils";

import Oestra from "@/icons/products/product-oestra-r-colored-label.svg";

import { sampleSteps } from "./sampleData";
import DesktopTabs from "./components/DesktopTabs";
import MobileCarousel from "./components/MobileCarousel";
import { GetStartedProps } from "./types";

const GetStarted = ({
    steps = sampleSteps,
    productBadge = <Oestra />,
    className,
    isElementorContainer = false,
    innerContainerClassName,
}: GetStartedProps) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const Container = isElementorContainer ? ElementorContainer : NextContainer;

    return (
        <section className={cn("overflow-hidden", className)}>
            <Container className={innerContainerClassName}>
                <div className="hidden md:block bg-softBlue rounded-2xl px-12 pt-14">
                    <DesktopTabs
                        steps={steps}
                        activeIndex={activeIndex}
                        onSelect={setActiveIndex}
                        productBadge={productBadge}
                    />
                </div>
            </Container>

            <MobileCarousel
                steps={steps}
                productBadge={productBadge}
            />
        </section>
    );
};

export default GetStarted;
